/* Countdown Timer — custom element for Dawn theme
   Used by the Custom Content section countdown block.
   No dependencies. Safe to load deferred.
*/
if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this.deadline = new Date(this.dataset.deadline).getTime();
      this.daysEl    = this.querySelector('[data-days]');
      this.hoursEl   = this.querySelector('[data-hours]');
      this.minutesEl = this.querySelector('[data-minutes]');
      this.secondsEl = this.querySelector('[data-seconds]');
      this.tick();
      this._interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this._interval);
    }

    pad(n) {
      return String(n).padStart(2, '0');
    }

    tick() {
      const diff = this.deadline - Date.now();

      if (diff <= 0) {
        clearInterval(this._interval);
        this.daysEl    && (this.daysEl.textContent    = '00');
        this.hoursEl   && (this.hoursEl.textContent   = '00');
        this.minutesEl && (this.minutesEl.textContent = '00');
        this.secondsEl && (this.secondsEl.textContent = '00');
        this.dispatchEvent(new CustomEvent('countdown:ended', { bubbles: true }));
        return;
      }

      const days    = Math.floor(diff / 86400000);
      const hours   = Math.floor((diff % 86400000) / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);

      this.daysEl    && (this.daysEl.textContent    = this.pad(days));
      this.hoursEl   && (this.hoursEl.textContent   = this.pad(hours));
      this.minutesEl && (this.minutesEl.textContent = this.pad(minutes));
      this.secondsEl && (this.secondsEl.textContent = this.pad(seconds));
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}
